import styled from 'astroturf/react';
import Tabs from 'rc-tabs';
import ScrollableTabBar from 'rc-tabs/lib/ScrollableTabBar';

const TabsWrapper = styled(Tabs)`
  margin: 0 -30px 0 -15px;
  border-bottom: 0;
  overflow: visible !important;

  &.contentHeight65Vh {
    div[class*='rc-tabs-content'] {
      max-height: 65vh;
      overflow: auto;
    }
  }
`;

const TabBarWrapper = styled(ScrollableTabBar)`
  border-bottom: 0 !important;
  position: relative;
  user-select: none;

  &::after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    opacity: 0.2;
    border-top: solid 1px var(--ph-gray-500);
    z-index: -1;
    content: '';
  }

  div[class*='rc-tabs-tab'] {
    padding: 7px 15px;
    font-size: var(--ph-text-sm);
    color: var(--ph-gray-500);
    font-stretch: normal;
    font-weight: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    margin-right: 0 !important;

    &:first-child {
      margin-left: 10px;
    }
  }

  div[class*='rc-tabs-tab-active'] {
    position: relative;
    background: var(--white);
    box-shadow: var(--ph-box-shadow-sm);
    color: var(--ph-light-blue-500);
    border-top-left-radius: var(--ph-border-radius-sm);
    border-top-right-radius: var(--ph-border-radius-sm);
  }

  div[class*='rc-tabs-nav-animated'] {
    margin-left: 30px;
  }
`;

const TabPaneWrapper = styled('div')`
  padding: 20px 40px;
  background-color: var(--white);
  overflow: visible !important;

  &.withoutPadding {
    padding: 0 0 0 8px;
  }
`;

export default {
  TabsWrapper,
  TabBarWrapper,
  TabPaneWrapper,
};
